import type { seoPageTypes } from 'BreetComponents';
import type { DropdownOptionType, ITransactionHistory, TransactionHistoryType } from 'BreetHelpers';

export interface IWalletTransactionsFilter {
	handleSelectedFilterChange?: (selectedFilters?: Record<string, DropdownOptionType | undefined>) => void;
	settlementValue: string;
	statusValue: string;
	setSettlementValue: (value: string) => void;
	setStatusValue: (value: string) => void;
	toggleVisibility?: () => void;
}

export const getTransactionEditsType = (row: ITransactionHistory<TransactionHistoryType>) =>
	row.isCredit ? 'Admin Credit' : 'Admin Debit';

export const currencyDisplayNames: Record<string, string> = {
	USD: 'USD',
	NGN: 'Naira',
	GHS: 'Cedis',
};

export interface ITableColumnDestination {
	row: ITransactionHistory<TransactionHistoryType>;
}

export interface ITableColumnType {
	row: ITransactionHistory<TransactionHistoryType>;
}

export interface ITableColumnTransactionDetails {
	row: ITransactionHistory<TransactionHistoryType>;
	onColumnClick?: () => void;
}

export interface IWalletTransactionProps {
	filterProps?: Record<string, string | boolean | number>;
	pageTitle: string;
	seoPage: seoPageTypes;
	hideWalletBalance?: boolean;
	hideNotification?: boolean;
	tip?: string;
}
